import React from "react";

const Conditions = () => {
    return <div className = 'body'>условия</div>;
}

export default Conditions;
